var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"application-form qualification-step"},[_c('Qualifications',{attrs:{"profile":_vm.profile,"requestGraduationDate":false,"withComponents":false}}),_c('v-btn',{attrs:{"color":_vm.themes.candidate.light.primaryActionButton,"block":""},on:{"click":function($event){return _vm.$emit('input')}}},[_vm._v("\n    Save\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }